import { get } from "../methods";
function getCoupon(id, headers = {}) {
  return get({
    url: `api/user/billing/coupon`,
    payload: { ref: id },
    headers
  });
}
export {
  getCoupon as default
};
